import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from './user';
import { environment } from '../../environments/environment';
import { MD5UtilService } from '../services/MD5Util.service';
import { FormGroup } from '@angular/forms';
@Injectable()
export class AuthService {
   private messageSource = new BehaviorSubject<boolean>(false);
   currentMessage = this.messageSource.asObservable();
   private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   private isAgent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   private currentUserSubject: BehaviorSubject<User>;
   public currentUser: Observable<User>;
   private transfromWallet: BehaviorSubject<any>;
   rechagehappenfromwallet$: Observable<any>;
   private sinavShowhidw: BehaviorSubject<any>;
   retailerChatSubject = new BehaviorSubject('');

   SideNavClick$: Observable<any>;
   changeMessage(isCallAccepted: boolean) {
      this.messageSource.next(isCallAccepted);
      console.log(this.messageSource.next(isCallAccepted),'service flag change value show ')
    }
   get isLoggedIn() {
      return this.loggedIn.asObservable();
   }
   isLogin: any;

   isLoggedIn2() {
      const loggedIn = localStorage.getItem('wallet-token');
      if (localStorage.getItem('wallet-token')) this.isLogin = true;
      else this.isLogin = false;
      return this.isLogin;
    }

   get IsAgent() {
      return this.isAgent.asObservable();
   }
   constructor(
      private router: Router,
      private http: HttpClient,
      private md5Util:MD5UtilService
   ) {
      const token =localStorage.getItem('wallet-token');
      this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
      this.currentUser = this.currentUserSubject.asObservable();
      this.transfromWallet = new BehaviorSubject<any>('transinit');
      this.rechagehappenfromwallet$ = this.transfromWallet.asObservable();
      this.sinavShowhidw = new BehaviorSubject<any>('false');
      this.SideNavClick$ = this.sinavShowhidw.asObservable();
   }
   public get currentUserValue(): User {
      return this.currentUserSubject.value;
   }
   sideNav(show) {
      this.sinavShowhidw.next(show);
   }
   getIp() {
      return this.http.get('https://api.ipify.org/?format=json');
      // return this.http.get('https://json.geoiplookup.io/?callback=?');

     
   }
   loginWithOtp(form,ip,otpType) {

      const data = {

         mobile: form.userName,
         ip: ip,
         password: form.password.trim(),
         type:"Web",
         otpType:otpType
      }
      
      return this.http.post(`${environment.youmudraUrl}/v1/retailor/loginWithOtp`, data);

   }
   validateRetOtp2(form:any,value:any){
      const data = {

         otp: form,
         refNumber: value

     
    }
      return this.http.post<any>(`${environment.validate_url}/ym/retailor/login`, data)
   }
   validateRetOtp(otpform, mobileform,ip,otpType) {
      console.log(otpform, mobileform)

      const data = {

         mobile: mobileform.userName,
         otp: otpform.enterOtp.toString(),
         password: mobileform.password,
         ip: ip,
         otpType:otpType

       
      }
      console.log("data::::::::::", data)
      return this.http.post<any>(`${environment.youmudraUrl}/v1/retailor/validateloginOtp`, data).pipe(map(user => {

         // login successful if there's a jwt token in the response
         if (user.status && user.status == 200) {
            console.log('user 121::::--:::', user);
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            let currentUserDetails = {};
            currentUserDetails['data'] = {
               expiryTime: user.expiryTime,
               token: user.token,
               eamil: user.user.email,
               uacid: user.user.uacid,
               firstName: user.user.firstname,
               lastName: user.user.lastname,
               walletToken: user.walletResut.accessToken,
               agent_id: user.user._id,
               agentId: user.kyc.retailorId,
            }
            localStorage.setItem('currentUser', JSON.stringify(currentUserDetails));
            this.currentUserSubject.next(user);
            this.isAgent.next(true);
         }
         return user;
      }));




   }
   loginWithOtp2(mobileform:any,otp:any){
      const data = {

         mobileNumber: mobileform.userName,
         otpOn:otp


       
      }
      return this.http.post<any>(`${environment.validate_url}/ym/retailor/login/sendotp`, data)

   }
   rechargeListner() {
      this.transfromWallet.next('transhappened'); 
   }
   logout() {
      if (localStorage.getItem('currentUser') && (JSON.parse(localStorage.getItem('currentUser'))).data && (JSON.parse(localStorage.getItem('currentUser'))).data.token) {
         
            const retailorLogout = {
               walletToken: localStorage.getItem('wallet-token'),
               token: (JSON.parse(localStorage.getItem('currentUser'))).data.token,
            }
            let headers = new HttpHeaders();
            headers = headers.append("Authorization",localStorage.getItem('wallet-token'));
        
            return this.http.post(`${environment.youmudraUrl}/v1/retailor/logout`, retailorLogout,{headers:headers}).pipe(map((user: any) => {
               // if (user.status == 200) {
               // remove user from local storage to log user out
               localStorage.removeItem('currentUser');
               this.currentUserSubject.next(null);
               // }
               return user;
            }));
         

      } else {
         // remove user from local storage to log user out
         localStorage.removeItem('currentUser');
         this.currentUserSubject.next(null);
      }

      // return this.http.get(`${environment.baseUrl}/v1.0/agentapi/agent/logout`, { headers: headers })
   }
   logout2() {
      let headers = new HttpHeaders();
            headers = headers.append("authToken",localStorage.getItem('wallet-token'));
        
            return this.http.get(`${environment.validate_url}/ym/retailor/logout`,{headers:headers})

      // return this.http.get(`${environment.baseUrl}/v1.0/agentapi/agent/logout`, { headers: headers })
   }
   
   forcelogoutgetOtp(params) {
      let userType = localStorage.getItem('userType');
      if (userType == 'alliances-login') {
         return this.http.post(`${environment.allienceBaseUrl}/v1/alliance/resetSession`, params);
      } else {
         return this.http.post(`${environment.allienceBaseUrl}/v1/agent/resetSession`, params);
      }
   }
   validateOtp(otp) {
      let userType = localStorage.getItem('userType');
      if (userType == 'alliances-login') {
         return this.http.post(`${environment.allienceBaseUrl}/v1/alliance/sendOtp`, otp)
            .pipe(map((user: any) => {
               console.log(user);
               // login successful if there's a jwt token in the response
               if (user && user['data'].email) {
                  // store user details and jwt token in local storage to keep user logged in between page refreshes
                  localStorage.setItem('currentUser', JSON.stringify(user));
                  this.currentUserSubject.next(user);
                  this.isAgent.next(true);
               }
               return user;
            }));
      } else {
         return this.http.post(`${environment.allienceBaseUrl}/v1/agent/sendOtp`, otp)
            .pipe(map((user: any) => {
               console.log(user);
               // login successful if there's a jwt token in the response
               if (user && user['data'].email) {
                  // store user details and jwt token in local storage to keep user logged in between page refreshes
                  localStorage.setItem('currentUser', JSON.stringify(user));
                  this.currentUserSubject.next(user);
                  this.isAgent.next(true);
               }
               return user;
            }));
      }

   }
   forgetPassword(params) {
    
      return this.http.post(`${environment.youmudraUrl}/v1/user/password/forget`, params);
   }

   getToken() {
   //    var obj = {
   //       db: "yourmudra26june",
   //       username: "yourmudra@yourmudra.com",
   //       password: "123456",
   //       x_type: "admin",
   //    };
   //    let headers = new HttpHeaders();
   //    headers = headers.append("Content-Type", "text/plain");
   //    let options = {
   //       headers: headers,
   //    };
   //    var url = environment.odooUrl + "auth/get_tokens";
   //    return this.http.post(url, obj, options);
   }

   gettopretailerbyid(id, access_token) {
      let headers = new HttpHeaders();
      headers = headers.append("access-token", access_token);
      headers = headers.append("Content-Type", "text/plain");
      let options = {
         headers: headers,
      };
      return this.http.get(`${environment.odooUrl}topretailer/${id}`, options);
   }


   getRetailerWalletBalance(){
      const token = localStorage.getItem('wallet-token');
   
      let headers = new HttpHeaders();

      headers = headers.append('X-AUTH-TOKEN',token);   
      headers = headers.append('apikey', environment.api_key);
   
      return this.http.get(`${environment.baseUrl}/v1/ym/retailor/getbalance`, {headers:headers});
   }
getAllCommissionDistributorByDate(startDate,endDate) {
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');

  let headers = new HttpHeaders();
  headers = headers.append("authToken",token);
  headers = headers.append('apikey', environment.api_key);

  return this.http.get(
    `${environment.baseUrl}/v1/ym/retailor/getcommision/byrange/all?startDate=${startDate}&endDate=${endDate}`,
    { headers: headers }
  );
}

//tds certificate ............................

downloadTds(info){
   var pan=this.md5Util.getAESEncrption(info[0]);
   // var quarter=info[1];
   // var fy=info[2];
   
   let headers = new HttpHeaders();
   headers = headers.append("Authorization",localStorage.getItem('wallet-token'));
   var data={
      "pan":pan,
      "quarter":info[1],
      "fy":info[2]
   }
   return this.http.post(`${environment.youmudraUrl}/v1/user/downloadTds`,data,
   {responseType: 'blob' as 'blob',headers:headers}
   );
 }
 
 downloadTds2(info){
   var pan=this.md5Util.getAESEncrption(info[0]);
   // var quarter=info[1];
   // var fy=info[2];
   
   let headers = new HttpHeaders();
   headers = headers.append("authToken",localStorage.getItem('wallet-token'));
   var data={
      "quater":info[1],
      "financialYear":info[2]
   }
   return this.http.post(`${environment.validate_url}/ym/retailer/get/tds/certificate`,data,
   {headers:headers}
   );
 }
 ////GET CONTACT US DETAILS
getContactUsDetails(){
   let headers = new HttpHeaders();
   headers = headers.append('apikey', environment.support_api_key);
  
   return this.http.get(
     `${environment.contactus_url}ym/support/get/support`,{headers:headers});
     
 }

 ////////DOWNLOAD PDF
 downloadPdf(transactionref){
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   headers = headers.append('apikey', environment.api_key);
   return this.http.get(`${environment.validate_url}/ym/retailor/generatepdf/${transactionref}`,
    {headers: headers});
      
  }

  //service notification alert
//   /v1/ym/retailor/getactive/alert
getactiveAlert(service){
   var messageActiveStatus='ACTIVE';
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   headers = headers.append('apikey', environment.api_key);
   return this.http.get(`${environment.validate_url}/ym/retailor/getactive/alert?messageActiveStatus=${messageActiveStatus}&service=${service}`,
    {headers: headers});
      
  }

  getserviceAlert(service){
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   // headers = headers.append('apikey', environment.api_key);
   return this.http.get(`${environment.wallet_url2}/ym/check/service/status?data=${service}`,
    {headers: headers});
      
  }
  check2fa(service){
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   // headers = headers.append('apikey', environment.api_key);
   return this.http.get(`${environment.wallet_url2}/ym/aeps/fingpay/2fa/check?provider=${service}`,
    {headers: headers});
      
  }
  getDevicesApi(){
   let headers = new HttpHeaders();
   headers = headers.append('apikey', environment.api_key);
   return this.http.get(`${environment.validate_url}/ym/admin/get/device`,
    {headers: headers});
      
  }

  ///////////////////////////Retailer Notifications//////////////////////////////
getRetailerNotificationsApi(type) {
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   return this.http.get(`${environment.wallet_url2}/ym/notification/content/get/?type=${type}`,{ headers: headers }
   );
 }
  ///////////////////////////Retailer Notifications //////////////////////////////
 
  ///////////////////////////Retailer Certificate//////////////////////////////
  generateCertificateApi() {
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   return this.http.get(`${environment.wallet_url2}/ym/retailor/generatepdf/identity`,{ headers: headers }
   );
 }
  ///////////////////////////Retailer Certificate //////////////////////////////

    ///////////////////////////Retailer Commission Plan //////////////////////////////
    retailerCommissionApi() {
      // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
      var token = localStorage.getItem('wallet-token');
      let headers = new HttpHeaders();
      headers = headers.append("authToken",token);
      return this.http.get(`${environment.wallet_url2}/ym/retailor/get/commissionplan`,{ headers: headers }
      );
    }
     ///////////////////////////Retailer Commission Plan //////////////////////////////

  /////////////////////////// Request mATM //////////////////////////////
  requestmatm() {
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   return this.http.get(`${environment.wallet_url2}/matm/retailer/requestmatm`,{ headers: headers }
   );
 }
  /////////////////////////// Request mATM  //////////////////////////////

    /////////////////////////// COMPLAINT MODULE //////////////////////////////
    getComplaint(status) {
     var X_USER_ID =localStorage.getItem('uniqueName');
     let headers = new HttpHeaders();
     headers = headers.append("X-USER-ID",X_USER_ID);
      return this.http.get(`${environment.complaint_url}complaint/getall/bystatus?status=${status}`,{ headers: headers });
    }
    createComplaint(form,file,createdByName) {
      var description= form.details
      var sevice=form.sevice;
      var createdByCode=localStorage.getItem('uniqueName');
      const formData = new FormData();
      formData.append('file', file);
      // complaint/retailer/create?description=dhdsfs&createdByCode=fdsg&createdByName=sfss&sevice=MOBILE_RECHARGE
      return this.http.post(`${environment.complaint_url}complaint/retailer/create?description=${description}&createdByCode=${createdByCode}&createdByName=${createdByName}&sevice=${sevice}`,formData);
    }
    reply(form,complaintId,file){
      var description= form.description
      var createdByCode=localStorage.getItem('uniqueName');
      const formData = new FormData();
      formData.append('file', file);
      return this.http.post(`${environment.complaint_url}complaint/reply?complaintId=${complaintId}&description=${description}&createdBy=${createdByCode}`,formData);
    
      
    }
    getComplaintbyId(complaintId) {
      let headers = new HttpHeaders();
      headers = headers.append("X-YM-ID",'yourmudrasuperadmin');
      headers = headers.append("X-YM-SECRET",'yourmudrasuperadmin');
      return this.http.get(`${environment.complaint_url}admin/complaint/header/get/byid?complaintId=${complaintId}`,{ headers: headers });
     }

     setChat(chat) {
      this.retailerChatSubject.next(chat);
    }
    getChat() {
      return this.retailerChatSubject.asObservable();
    }
  
     /////////////////////////// COMPLAINT MODULE //////////////////////////////
   
   ///////////////////////////Retailer Earning Excel//////////////////////////////
getEarningExcel(service,retailerUniqueName,startDate,endDate) {
   return this.http.get(`${environment.excel_export}ym/admin/${service}/${retailerUniqueName}?startDate=${startDate}&endDate=${endDate}`,{responseType: 'blob' as 'blob'});
 }
  ///////////////////////////Retailer Earning //////////////////////////////
 
  getUsefullLinkListApi() {
   // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   return this.http.get(`${environment.walletUrl}/retailer/misc/url/get`,{ headers: headers }
   );
 }
 
 ////////////////////////////////////NSDL PAN Service////////////////////////////////
 generateUrl(form) {
   var token = localStorage.getItem('wallet-token');
   let headers = new HttpHeaders();
   headers = headers.append("authToken",token);
   return this.http.post(`${environment.nsdl_uat_url}generateurl`,form,{ headers: headers });
 }
 correctionUrl(form) {
   return this.http.post(`${environment.nsdl_uat_url}generateurl/forcorrection`,form);
 }
 ////////////////////////////////////NSDL PAN Service////////////////////////////////

}
